<p-dialog
  [header]="getOrganizationDialogHeader()"
  [(visible)]="visible"
  [style]="{ width: '50vw' }"
  [modal]="true"
  [closable]="false"
  [draggable]="false">

  <form [formGroup]="organizationForm" (ngSubmit)="onSubmit()">

    <app-input
      label="Organization Name"
      i18n-label="Organization name label@@organizationNameLabel"
      formControlName="name"
      [touched]="organizationForm.get('name')?.touched"
      [errorMessage]="organizationForm.get('name')?.errors"
      [required]="true"
    >
    </app-input>

    <app-input
      label="Email Address"
      i18n-label="Email address label@@emailAddressLabel"
      formControlName="email"
      [touched]="organizationForm.get('email')?.touched"
      [errorMessage]="organizationForm.get('email')?.errors"
      [required]="true"
    ></app-input>

    <app-input-select
      [filter]="true"
      label="Country"
      i18n-label="Country label@@countryLabel"
      [options]="countryOptions"
      optionLabel="label"
      optionValue="value"
      placeholder="Select Country"
      i18n-placeholder="Select country placeholder@@selectCountryPlaceholder"
      formControlName="country"
      [touched]="organizationForm.get('country')?.touched"
      [errorMessage]="organizationForm.get('country')?.errors"
      [required]="true"
    >
    </app-input-select>

    <app-input-select
      label="Locale"
      i18n-label="Locale label@@localeLabel"
      [options]="localeOptions"
      optionLabel="label"
      optionValue="value"
      placeholder="Select Locale"
      i18n-placeholder="Select locale placeholder@@selectLocalePlaceholder"
      formControlName="locale"
      [touched]="organizationForm.get('locale')?.touched"
      [errorMessage]="organizationForm.get('locale')?.errors"
      [required]="true"
    >
    </app-input-select>

    <ng-container *ngIf="isNewOrganization">
      <app-input-select
        label="Region"
        i18n-label="Region label@@regionLabel"
        [options]="regionList"
        optionLabel="name"
        optionValue="id"
        placeholder="Select Region"
        i18n-placeholder="Select region placeholder@@selectRegionPlaceholder"
        formControlName="regionId"
        [touched]="organizationForm.get('regionId')?.touched"
        [errorMessage]="organizationForm.get('regionId')?.errors"
        [required]="true"
      >
      </app-input-select>
    </ng-container>

    <div class="p-dialog-footer">

      <button
        pButton
        type="button"
        (click)="onCancel()"
        label="Cancel"
        i18n-label="@@cancelButton"
        class="p-button-text">
      </button>

      <button
        *ngIf="isNewOrganization"
        pButton
        type="submit"
        label="Create"
        i18n-label="@@createOrganizationButton"
        class="p-button-block">
      </button>
      <button
        *ngIf="!isNewOrganization"
        pButton
        type="submit"
        label="Save"
        i18n-label="@@saveOrganizationButton"
        class="p-button-block">
      </button>

    </div>

  </form>
</p-dialog>